enum IDType {
    ID_CARD = 'ID_CARD', // 身份证
    HOUSEHOLD_REGISTER = 'HOUSEHOLD_REGISTER', // 户口本
    HKMT_PASS_CARD = 'HKMT_PASS_CARD', // 港澳台通行证
    PASSPORT = 'PASSPORT', // 护照
    BANK_INFO = 'BANK_INFO', // 银行卡信息
    HANDHELD_ID_CARD = 'HANDHELD_ID_CARD', //手持身份证
}

const IDTypeOptions = [
    {
        id: IDType.ID_CARD,
        name: '身份证'
    },
    {
        id: IDType.PASSPORT,
        name: '护照'
    },
    {
        id: IDType.HOUSEHOLD_REGISTER,
        name: '户口本'
    },
    {
        id: IDType.HKMT_PASS_CARD,
        name: '港澳台通行证'
    },
]

const AddressVerifyScheduleStatus = {
    pass: 1,
    refuse: 2,
    waitingToInvite: 10,
    waitingForVerification: 11,
    risk: 7,
}

export {
    IDType,
    IDTypeOptions,
    AddressVerifyScheduleStatus
}

export const riskCodes = [300, 301, 302, 303, 304, 305, 306, 307, 308];

export const TWO_EL_NO_PASS_CODE = 315;

export const THREE_EL_NO_PASS_CODE = 316;

export const VERIFY_ERROR_CODE = 313;

export const PHONE_TIMES_LIMIT_CODE = 311;

export const BANK_CARD_NUM_ERROR_CODE = 317;

export const LINK_HAS_EXPIRED_CODE = 1004; // 邀请超时

export const ADDRESS_VERIFY_HAS_EXPIRED_CODE = 1005; // 验证超时


export enum EServerCode {
    SUCCESS = 200, // 成功
    LINKOUTTIME = 1003, // 链接过期
    NUMBERERROR = 1006, // 账号不正确
    PASSWORDERROR = 1007, // 密码错误
    LINKEXPIRES = 1008, // 链接失效
}


export enum EVerifyCode {
    SUCCESS = 1000, // 刷脸成功
    SYSTEM_ERROR = 1001, // 系统错误
    VERIFY_AORT = 1003, // 验证中断
    NETWORK_ERROR = 2002, // 网络错误
    CLIENT_TIME_ERROR = 2003, // 客户端设备时间错误
    VERIFY_FAIL = 2006, // 刷脸失败
}

export enum EVerifySubCode {
    VERIFY_SUCCESS = "Z5050", //人脸验证成功。
    UPLOAD_IMAGE_FAIL = "Z5051", //上传刷脸图片失败。
    DATA_ERROR_OR_EXCEPTION = "Z5052", //数据错误或程序异常。
    NETWORK_ERROR = "Z5053", //网络错误。
    CAMERA_NO_READY =  "Z5054", //摄像头无权限或无法获取摄像头数据。
    USER_CANCEL = "Z5055", //用户退出。
    VERIFY_LIMIT = "Z5056", //重试次数过多。
    UPLOAD_VIDEO_TIMEOUT = "Z5057", //视频上传超时。
    VIDEO_FORMAT_ERROR = "Z5058", //视频格式不满足要求。
    VERIFY_NO_FACE = "Z5059", //视频中无有效人脸。
    NO_SAME_PERSON_FACE = "Z5128", //验证不是同一个人。
}

export enum EVerifyMethod {
    MT = "MT", // 下行
    MO = "MO", // 上行
}

// 第三方平台修复方式
export enum EPlatFormType {
    WECHAT = 'wechat',
    BLIZZARD = 'blizzard',
    AMAZON = 'amazon',
    APPLEID = 'appleID',
    STEAM = 'steam',
    OTHER = 'other',
}

// 修复方式步骤
export enum EExtensionStep {
    EXT_FACE_RECOGNITION = 'EXT_FACE_RECOGNITION', // 芝麻信用
    EXT_CREDIT_SCORE_JUDGE = 'EXT_CREDIT_SCORE_JUDGE', // 人脸识别
    EXT_THIRD_PLATFORM_ACCOUNT_REPAIR = 'EXT_THIRD_PLATFORM_ACCOUNT_REPAIR', // 第三方平台账号修复
}

